import React, { useEffect, useState } from 'react';
import api from '../lib/api';
import { formatIDR, formatDateTime } from '../lib/format';
import MemberLayout from '../components/MemberLayout';
import { Card } from '../components/ui/card';
import { RiskAlert } from '../components/RiskAlert';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../components/ui/table';

export default function Practice() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get('/practice/account').then(r => setD(r.data)).catch(()=>{}); }, []);
  if (!d) return <MemberLayout><div className="h-64 flex items-center justify-center text-muted-foreground">Memuat...</div></MemberLayout>;

  const stats = [['Practice Capital', d.practice_capital],['Current Balance', d.current_balance],['P/L', d.pl],['Monthly Allocation', d.monthly_allocation],['Used Allocation', d.used_allocation],['Available', d.available]];

  return (
    <MemberLayout>
      <h1 className="font-display text-2xl sm:text-3xl font-bold">Trading Practice Program</h1>
      <p className="text-muted-foreground mt-1">Alokasi Modal Praktik Trading — tunduk pada aturan program & eligibilitas.</p>

      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 mt-6">
        {stats.map(([label,val]) => (
          <Card key={label} className="p-5"><div className="text-sm text-muted-foreground">{label}</div><div className={`font-display text-2xl font-bold mt-1 tabular-nums ${label==='P/L' ? (val>=0?'text-emerald-600':'text-red-600') : ''}`}>{label==='P/L' && val>0?'+':''}{formatIDR(val)}</div></Card>
        ))}
      </div>

      <div className="mt-6"><RiskAlert text={d.disclaimer} /></div>

      <Card className="p-5 mt-6">
        <h3 className="font-semibold mb-3">Riwayat Alokasi</h3>
        {d.transactions.length === 0 ? <p className="text-sm text-muted-foreground">Belum ada alokasi.</p> : (
          <Table><TableHeader><TableRow><TableHead>Tipe</TableHead><TableHead>Bulan</TableHead><TableHead className="text-right">Jumlah</TableHead><TableHead>Waktu</TableHead></TableRow></TableHeader>
            <TableBody>{d.transactions.map(t => (<TableRow key={t.tx_id}><TableCell>{t.type}</TableCell><TableCell>{t.month}</TableCell><TableCell className="text-right tabular-nums">{formatIDR(t.amount)}</TableCell><TableCell className="text-xs text-muted-foreground">{formatDateTime(t.created_at)}</TableCell></TableRow>))}</TableBody>
          </Table>
        )}
      </Card>
    </MemberLayout>
  );
}
